/**
 * Theme configuration
 * Defines brand information and color schemes
 */

// Brand configuration
export const brandConfig = {
  name: 'Jobotics',
  logo: '/header-logo.png',
  logoCollapsed: 'J',
  favicon: '/favicon.ico',
  description: 'AI-Powered Business Intelligence',
  slogan: 'Smart Analytics • Predictive Insights • Real-time Dashboards',
};

// Color theme configurations
export const themes = {
  light: {
    name: 'light',
    label: 'Light Mode',
    colors: {
      // Primary colors
      primary: '#3b82f6',
      primaryHover: '#2563eb',
      primaryLight: '#eff6ff',
      
      // Semantic colors
      secondary: '#10b981',
      accent: '#f59e0b',
      accentHover: '#d97706',
      accentLight: '#fef3c7',
      danger: '#ef4444',
      dangerLight: '#fef2f2',
      warning: '#d97706',
      warningLight: '#fffbeb',
      success: '#10b981',
      successLight: '#ecfdf5',
      info: '#3b82f6',
      infoLight: '#eff6ff',
      
      // Background colors
      background: '#f9fafb',
      surface: '#ffffff',
      surfaceHover: '#f3f4f6',
      
      // Text colors
      text: '#111827',
      textSecondary: '#6b7280',
      textMuted: '#9ca3af',
      textInverse: '#ffffff',
      
      // Button text colors
      buttonPrimaryText: '#ffffff',
      buttonSecondaryText: '#111827',
      buttonAccentText: '#ffffff',
      
      // Border colors
      border: '#e5e7eb',
      borderLight: '#f3f4f6',
      borderDark: '#d1d5db',
      borderFocus: '#3b82f6',
      
      // Shadows
      shadow: 'rgba(0, 0, 0, 0.1)',
      shadowLight: 'rgba(0, 0, 0, 0.05)',
      shadowMedium: 'rgba(0, 0, 0, 0.15)',
    },
  },
  dark: {
    name: 'dark',
    label: 'Dark Mode',
    colors: {
      // Primary colors
      primary: '#60a5fa',
      primaryHover: '#3b82f6',
      primaryLight: '#1e3a5f',
      
      // Semantic colors
      secondary: '#34d399',
      accent: '#fbbf24',
      accentHover: '#f59e0b',
      accentLight: '#451a03',
      danger: '#f87171',
      dangerLight: '#450a0a',
      warning: '#fbbf24',
      warningLight: '#451a03',
      success: '#34d399',
      successLight: '#022c22',
      info: '#60a5fa',
      infoLight: '#1e3a5f',
      
      // Background colors
      background: '#111827',
      surface: '#1f2937',
      surfaceHover: '#374151',
      
      // Text colors
      text: '#f9fafb',
      textSecondary: '#9ca3af',
      textMuted: '#6b7280',
      textInverse: '#111827',
      
      // Button text colors
      buttonPrimaryText: '#ffffff',
      buttonSecondaryText: '#f9fafb',
      buttonAccentText: '#111827',
      
      // Border colors
      border: '#374151',
      borderLight: '#4b5563',
      borderDark: '#1f2937',
      borderFocus: '#60a5fa',
      
      // Shadows
      shadow: 'rgba(0, 0, 0, 0.3)',
      shadowLight: 'rgba(0, 0, 0, 0.2)',
      shadowMedium: 'rgba(0, 0, 0, 0.4)',
    },
  },
  // Jobotics brand orange theme
  orange: {
    name: 'orange',
    label: 'Brand Orange',
    colors: {
      // Primary colors (using neutral colors for main UI elements)
      primary: '#0D0D12',
      primaryHover: '#1C1C21',
      primaryLight: '#F5F5F7',
      
      // Semantic colors
      secondary: '#3F3F45',
      accent: '#F1562B',           // Brand orange - use with restraint
      accentHover: '#ED582D',
      accentLight: '#FFF2ED',
      danger: '#EF4444',
      dangerLight: '#FEE2E2',
      warning: '#FABD2F',
      warningLight: '#FEF9C3',
      success: '#22C55E',
      successLight: '#DCFCE7',
      info: '#3B8FFA',
      infoLight: '#DBEAFE',
      
      // Background colors
      background: '#F5F5F7',
      surface: '#FFFFFF',
      surfaceHover: '#F5F5F7',
      
      // Text colors
      text: '#0D0D12',
      textSecondary: '#808087',
      textMuted: '#D1D1D6',
      textInverse: '#FFFFFF',
      
      // Button text colors
      buttonPrimaryText: '#FFFFFF',
      buttonSecondaryText: '#0D0D12',
      buttonAccentText: '#FFFFFF',
      
      // Border colors
      border: '#D1D1D6',
      borderLight: '#F5F5F7',
      borderDark: '#808087',
      borderFocus: '#F1562B',
      
      // Shadows
      shadow: 'rgba(13, 13, 18, 0.1)',
      shadowLight: 'rgba(13, 13, 18, 0.05)',
      shadowMedium: 'rgba(13, 13, 18, 0.15)',
    },
  },
};

// Default theme
export const defaultTheme = 'orange';

// Get theme configuration
export const getTheme = (themeName) => {
  return themes[themeName] || themes[defaultTheme];
};

// Get all available themes
export const getAvailableThemes = () => {
  return Object.keys(themes).map(key => ({
    name: themes[key].name,
    label: themes[key].label,
  }));
};

export default {
  brand: brandConfig,
  themes,
  defaultTheme,
};
